/* eslint-disable @next/next/no-img-element */

import Container from 'react-bootstrap/Container'
import styles from '../styles/VCF.module.scss'
import { Button, Image } from 'react-bootstrap'
import Head from 'next/head'

const companies = [
	{
		name: 'ALPSOFT TECHNOLOGIES',
		logo: '/img/vcf/futureTech/alpsoft.png',
	},
	{
		name: 'DXC Technology',
		logo: '/img/vcf/futureTech/dxc.png',
	},
	{
		name: 'HITACHI SOLUTIONS',
		logo: '/img/vcf/futureTech/hitachi.png',
	},
	{
		name: 'MindTeck',
		logo: '/img/vcf/futureTech/mindteck.png',
	},
	{
		name: 'Simba Telecom',
		logo: '/img/vcf/futureTech/simba.png',
	},
	{
		name: 'VINOVA',
		logo: '/img/vcf/futureTech/vinova.png',
	},
	{
		name: 'Vision Group',
		logo: '/img/vcf/futureTech/vision.png',
	},
	{
		name: 'Willowglen Services',
		logo: '/img/vcf/futureTech/willowglen.png',
	},
	{
		name: 'Xcellink',
		logo: '/img/vcf/futureTech/xcellink.png',
	}
]

const VCF = ({ eventData }: { eventData: { id: string; name: string; landingPageUrl: string; startDate: string; endDate: string } }) => {
	const eventName = eventData?.name || 'FutureTech Virtual Career Fair'
	const eventUrl = eventData?.landingPageUrl || '/FutureTechVirtualCareerFair'

	// Format date
	const formatDate = (dateString: string) => {
		return new Date(dateString).toLocaleDateString('en-GB', { 
			day: 'numeric', 
			month: 'long', 
			year: 'numeric' 
		})
	}

	return (
		<>
			<Head>
				<title>
					{eventName}
				</title>
				<link rel="shortcut icon" href="/img/vcf/favicon.png" />
				<meta
					property="og:url"
					content={eventUrl}
				/>
				<meta property="og:type" content="article" />
				<meta property="og:title" content={eventName} />
				<meta property="og:description" content={eventName} />
				<meta property="og:image" content={'/img/vcf/favicon.png'} />
				<meta name="description" content={eventName} />
			</Head>
			<Container className={styles.container}>
				<h1 className={styles.title}>
        			FutureTech Virtual Career Fair
				</h1>
				<h2 className={styles.subtitle}>
					{`${formatDate(eventData.startDate)} - ${formatDate(eventData.endDate)}`}
				</h2>
				<Image className={styles.banner} src="/img/vcf/futureTech/banner.png" alt="banner" />
				<h5 className={styles.contentTitle}>
					The future of work is digital — and your next opportunity could be here.
				</h5>

				<div className={styles.content}>
					<p>
					Whether you’re looking to build, manage, or support digital solutions, this fair opens doors to career possibilities across Singapore’s fast-growing tech sector. Take the next step toward a future-ready role and connect with employers shaping the digital economy. Apply now!
					</p>
				</div>

				<h5 className={styles.contentTitle}>Participating Companies</h5>
				<div className={styles.companies}>
					{companies.map((company, index) => (
						<div className={styles.company} key={index}>
							<img src={company.logo} alt={company.name} />
							<p>{company.name}</p>
						</div>
					))}
				</div>
				<a href={`/event/${eventData?.id}`} target="_blank" rel="noreferrer">
					<Button className={styles.button}>Apply Now</Button>
				</a>
				<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '32px' }}>
					<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
						<p style={{ margin: 0, fontWeight: 'bold' }}>Organized By:</p>
						<img src={'/img/vcf/e2i.png'} alt={'e2i'} style={{ maxHeight: '60px' }} />
					</div>
				</div>
			</Container>
		</>
	)
}

export default VCF

// check if FutureTech event is still active
export async function getServerSideProps() {
	try {
		const { createClient } = await import('graphqurl')

		const client = createClient({
			endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string,
			headers: {
				'X-Hasura-Admin-Secret': process.env.HASURA_ADMIN_SECRET as string,
			},
		})

		const hasuraQuery = await client.query({
			query: `
				query {
					Event(where: {
						landingPageUrl: {_eq: "/FutureTechVirtualCareerFair"}
						startDate: {_lte: "now()"}
						endDate: {_gte: "now()"}
					}) {
						id
						landingPageUrl
						name
						startDate
						endDate
					}
				}
			`,
		})

		const { data: { Event: events } } = hasuraQuery

		// if event not active, return 404
		if (!events || events.length === 0) {
			return {
				notFound: true,
			}
		}

		return {
			props: {
				eventData: {
					id: events[0].id,
					name: events[0].name,
					landingPageUrl: events[0].landingPageUrl,
					startDate: events[0].startDate,
					endDate: events[0].endDate
				}
			},
		}
	} catch (error) {
		console.error('Error checking event status:', error)
		return {
			notFound: true,
		}
	}
}
